import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { storableError } from '../../util/errors';
import { COLLECTION_LISTING_TYPE, visibleCollectionPieces } from '../../util/collections';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

import { collectionImageParams } from '../CollectionPage/CollectionPage.duck';

// Oversigten viser samlere, ikke stykker. Vi henter de nyeste stykker og
// grupperer dem pr. samler - så en aktiv samler kommer naturligt øverst,
// uden at vi skal vedligeholde et separat register over samlinger.
const MAX_PIECES = 100;

const queryAllCollectionsPayloadCreator = (
  { config },
  { dispatch, rejectWithValue, extra: sdk }
) => {
  return sdk.listings
    .query({
      pub_listingType: COLLECTION_LISTING_TYPE,
      perPage: MAX_PIECES,
      sort: '-createdAt',
      ...collectionImageParams(config?.layout?.listingImage),
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      const pieceRefs = visibleCollectionPieces(response.data.data).map(({ id, type }) => ({
        id,
        type,
      }));
      return { pieceRefs };
    })
    .catch(e => rejectWithValue(storableError(e)));
};

export const queryAllCollectionsThunk = createAsyncThunk(
  'CollectionsPage/queryAllCollections',
  queryAllCollectionsPayloadCreator
);

const initialState = {
  pieceRefs: [],
  queryError: null,
  queryInProgress: false,
};

const collectionsPageSlice = createSlice({
  name: 'CollectionsPage',
  initialState,
  reducers: {
    setInitialState: () => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(queryAllCollectionsThunk.pending, state => {
        state.queryInProgress = true;
        state.queryError = null;
      })
      .addCase(queryAllCollectionsThunk.fulfilled, (state, action) => {
        state.queryInProgress = false;
        state.pieceRefs = action.payload.pieceRefs;
      })
      .addCase(queryAllCollectionsThunk.rejected, (state, action) => {
        state.queryInProgress = false;
        state.pieceRefs = [];
        state.queryError = action.payload;
      });
  },
});

export const { setInitialState } = collectionsPageSlice.actions;
export default collectionsPageSlice.reducer;

export const loadData = (params, search, config) => dispatch => {
  dispatch(setInitialState());
  return dispatch(queryAllCollectionsThunk({ config }));
};
